import React from 'react';
import { motion } from 'framer-motion';
import { Users, Briefcase, Brain, TrendingUp, Layers, ArrowRight } from 'lucide-react';
import './WhoWeWorkWith.css';

const CALENDLY_URL = 'https://calendly.com/aventalentadvisory/o-1-visa-consultation';

function WhoWeWorkWith() {
  const profiles = [
    { icon: <Briefcase size={20} />, title: 'Founders and startup leaders' },
    { icon: <Users size={20} />, title: 'Senior consultants and independent advisors' },
    { icon: <Brain size={20} />, title: 'Data scientists, AI/ML specialists, and researchers' },
    { icon: <TrendingUp size={20} />, title: 'Product, strategy, and growth leaders' },
    {
      icon: <Layers size={20} />,
      title: 'Highly accomplished professionals with project-based or multi-employer work',
    },
  ];

  return (
    <section id="who-we-work-with" className="who-section">
      <div className="section-container">
        <motion.div
          className="who-grid"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="who-intro">
            <h2 className="who-title">Who We Work With</h2>
            <p className="who-description">
              Our services are designed for professionals whose work does not fit neatly into
              traditional employment-sponsored visa models.
            </p>
          </div>

          <div className="who-profiles">
            {profiles.map((profile, index) => (
              <motion.div
                key={index}
                className="profile-item"
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
              >
                <div className="profile-icon">{profile.icon}</div>
                <span className="profile-title">{profile.title}</span>
              </motion.div>
            ))}

            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="who-cta-link"
            >
              Not sure if you qualify? Book a consultation to discuss your profile.
              <ArrowRight size={16} />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default WhoWeWorkWith;
